(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product__form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        
        const fadeElements = document.querySelectorAll('.fade-in');

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target); // opcional: deja de observar después del fade
            }
          });
        }, { threshold: 0.2 }); // 20% visible

        fadeElements.forEach(el => observer.observe(el));
      });
  } catch(e) { console.error(e); }
})();

})();
